import { AxiosInstance } from 'axios';

const userService = ({
  GateWayInstance,
  OfficialGateWayInstance,
}: {
  GateWayInstance: AxiosInstance;
  OfficialGateWayInstance: AxiosInstance;
}) => ({
  getContactRes() {
    return OfficialGateWayInstance.get(`/user`);
  },
});

export default userService;
